	
import axios from "axios";






//export const baseURL="https://farmasis-tutoriales-back-production.up.railway.app";
export const baseURL="https://api.videotutoriales.farmasis.site";
export const baseURLStatic="http://localhost:3001";
//export const baseURLStatic="https://farmasis-api-static-production.up.railway.app";
//export const baseURLCompartido="https://farmasis-tutoriales-front-production.up.railway.app";
export const baseURLCompartido="https://videotutoriales.farmasis.site";
	





export let validateUser=async(name,password)=>{
	try{
		let validateCredentials=await axios.post(baseURL+"/login",{user:name,password:password},{
	    										headers:{'Content-Type': 'application/json'}});
			
			//window.localStorage.setItem("JWT",validateCredentials.data);
			return validateCredentials
	}
	catch(err){console.log(err);throw new Error(err)}	
};	

export let getData=async()=>{	 
	try{
		let dataApi=await axios( baseURL+"/farmasistutorials");
		let datos=dataApi.data;
		return datos
	}
	catch(err){throw new Error(err.message)}
};

export let getRutas=async()=>{	 
	try{
		let dataApi=await axios( baseURL+"/rutas/paso");
		let datos=dataApi.data;
		return datos
	}
	catch(err){throw new Error(err.message)}
};



//export const getToken=()=>{
//	 const token=window.localStorage.getItem("JWT");
//	 return token
//}

	